import { useEffect, useState } from 'react';

import { getProxiedCardImageUrl } from '../../features/utils';

function CardZoomModal({ card, onClose }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const imgUrl = getProxiedCardImageUrl(card.imgUrl);

  return (
    <button
      type="button"
      className="effects-editor__zoom-backdrop"
      onClick={onClose}
      aria-label={`Close ${card.name} zoom`}
    >
      <img className="effects-editor__zoom-image" src={imgUrl} alt={card.name} />
      <p className="effects-editor__zoom-caption">
        {card.name} · {card.id}
      </p>
    </button>
  );
}

export default function CardPreview({ card }) {
  const [zoomOpen, setZoomOpen] = useState(false);

  if (!card?.imgUrl) return null;

  const imgUrl = getProxiedCardImageUrl(card.imgUrl);

  return (
    <>
      <div className="effects-editor__card-preview">
        <button
          type="button"
          className="effects-editor__card-preview-btn"
          onClick={() => setZoomOpen(true)}
          aria-label={`Zoom ${card.name}`}
        >
          <img src={imgUrl} alt={card.name} loading="lazy" />
        </button>
        <div className="effects-editor__card-preview-info">
          <strong>{card.name}</strong>
          <span>{card.id}</span>
          {card.type && <span className="effects-editor__card-preview-type">{card.type}</span>}
          <button type="button" className="effects-editor__btn effects-editor__card-preview-zoom" onClick={() => setZoomOpen(true)}>
            Zoom
          </button>
        </div>
      </div>
      {zoomOpen && <CardZoomModal card={card} onClose={() => setZoomOpen(false)} />}
    </>
  );
}
